import { type ComponentPropsWithoutRef, memo } from 'react';
import { getStableHexColor } from '@/shared/utils/getStableHexColor';
import { cn } from '@/utils/tailwind.util';
const TEXT_AVATAR_SIZE_CLASS_NAMES = {
  xs: 'size-[24px] text-caption-md-semibold',
  sm: 'size-[30px] text-body-md-semibold',
  md: 'size-[40px] text-body-md-semibold',
  xl: 'size-[96px] text-display-sm-extrabold'
} as const;
type TextAvatarSize = keyof typeof TEXT_AVATAR_SIZE_CLASS_NAMES;
export interface TextAvatarProps extends ComponentPropsWithoutRef<'span'> {
  text: string;
  colorSeed?: string;
  size?: TextAvatarSize;
}
const getDisplayText = (text: string) => text.trim().slice(0, 2) || '?';
export const TextAvatar = memo(function TextAvatar({
  text,
  colorSeed,
  size = 'md',
  className,
  style,
  ...props
}: TextAvatarProps) {
  return <span className={cn('inline-flex shrink-0 items-center justify-center rounded-full text-inverse', TEXT_AVATAR_SIZE_CLASS_NAMES[size], className)} style={{
    backgroundColor: getStableHexColor(colorSeed ?? text),
    ...style
  }} {...props}>
      {getDisplayText(text)}
    </span>;
});